<template>
  <div class="dashboard_warp">
    <div class="overview-toolbar">
      <div>
        <div class="overview-title">经营概览</div>
        <div class="overview-description">{{ summaryDescription }}</div>
      </div>
      <div class="overview-filter">
        <el-radio-group
          v-model="summaryPeriod"
          size="small"
          @change="onSummaryPeriodChange"
        >
          <el-radio-button label="today">今日</el-radio-button>
          <el-radio-button label="week">本周</el-radio-button>
          <el-radio-button label="custom">自定义</el-radio-button>
          <el-radio-button label="total">累计</el-radio-button>
        </el-radio-group>
        <el-date-picker
          v-if="summaryPeriod === 'custom'"
          v-model="summaryCustomTime"
          class="overview-date-picker"
          type="daterange"
          size="small"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :clearable="false"
          @change="onSummaryCustomTimeChange"
        >
        </el-date-picker>
      </div>
    </div>
    <div class="home-top">
      <div class="top-panle" v-for="(item, index) in topList" :key="index">
        <img :src="item.img" alt="" />
        <div class="top-panle-right">
          <span class="text-18 size-191">{{ item.text }}</span>
          <span class="text-40 size-000 text-bold">{{ item.value }}</span>
          <span v-if="summaryPeriod !== 'total'" class="text-16 size-4a4"
            >{{ comparisonLabel
            }}<span
              :style="{
                'margin-left': '5px',
                color:
                  item.change > 0
                    ? '#00BA3C'
                    : item.change < 0
                    ? '#FF2440'
                    : '#666'
              }"
              >{{ formatSignedChange(item.change, item.metricType) }}</span
            ></span
          >
          <span v-else class="text-16 size-4a4">累计数据</span>
        </div>
      </div>
    </div>
    <div class="home-mid">
      <div class="home-mid-top">
        <div class="mid-top-left">
          <div
            class="min-left-list"
            v-for="(item, index) in midList"
            :key="index"
            @click="onMid(index)"
          >
            <span
              class="text-18"
              :style="{ color: index == curMid ? '#000' : '#666' }"
              >{{ item }}</span
            >
            <div class="mid-line" v-if="index == curMid"></div>
          </div>
        </div>
        <div class="mid-top-right">
          <span v-if="summaryPeriod === 'custom'" class="custom-chart-hint"
            >图表同步展示所选时间范围</span
          >
          <template v-else>
            <span
              class="text-14"
              :style="{
                color: 0 == rightMid ? '#7732FC' : '#666',
                'margin-right': '24px',
                cursor: 'pointer'
              }"
              @click="onRightMid(0)"
              >本周</span
            >
            <span
              class="text-14"
              :style="{
                color: 1 == rightMid ? '#7732FC' : '#666',
                'margin-right': '24px',
                cursor: 'pointer'
              }"
              @click="onRightMid(1)"
              >本月</span
            >
            <span
              class="text-14"
              :style="{
                color: 2 == rightMid ? '#7732FC' : '#666',
                'margin-right': '24px',
                cursor: 'pointer'
              }"
              @click="onRightMid(2)"
              >本年</span
            >
            <el-date-picker
              v-model="curTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="dateChange"
            >
            </el-date-picker>
          </template>
        </div>
      </div>
      <div class="home-mid-bottom" id="chart"></div>
    </div>
    <div class="mid-bottom-list-panel">
      <div
        class="list-box"
        @click="onDetail(item)"
        v-for="(item, index) in bottomList"
        :key="index"
        :style="{ background: item.color }"
      >
        <span class="text-4a4 text-16">{{ item.text }}</span>
        <span class="text-191 text-20 text-bold">{{ item.value }}</span>
        <i
          class="el-icon-arrow-right list-box-jiao"
          style="font-size:14px;color:#4a4a4a"
        />
      </div>
    </div>
    <div class="bottom-panel">
      <div class="bottom-left-panel">
        <span class="text-000 text-18" style="dispaly:block">商品销量排行</span>
        <el-table
          :data="leftTableList"
          style="width: 100%"
          :cell-style="{ border: '0px', padding: '5px 0', height: '20px' }"
          :header-cell-style="{
            border: '0px',
            height: '20px',
            'min-height': '20px',
            padding: '5px 0'
          }"
        >
          <el-table-column label="排名" width="48" align="center">
            <template slot-scope="scope">
              <img
                v-if="scope.row.rankNum == 1"
                src="../../assets/dashboard/rank_0.png"
                class="rank-img"
              />
              <img
                v-if="scope.row.rankNum == 2"
                src="../../assets/dashboard/rank_1.png"
                class="rank-img"
              />
              <img
                v-if="scope.row.rankNum == 3"
                src="../../assets/dashboard/rank_2.png"
                class="rank-img"
              />
              <span v-if="scope.row.rankNum > 3">{{ scope.row.rankNum }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="userName"
            label="商品图"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <img :src="scope.row.mainGraph" class="group-img" />
            </template>
          </el-table-column>
          <el-table-column
            prop="goodsName"
            align="left"
            show-overflow-tooltip
            label="商品名称"
          >
          </el-table-column>
          <el-table-column
            prop="unitPrice"
            align="center"
            show-overflow-tooltip
            label="单价"
          >
          </el-table-column>
          <el-table-column
            prop="buyNum"
            align="center"
            show-overflow-tooltip
            label="销量"
          >
          </el-table-column>
          <el-table-column
            prop="salesAmount"
            align="center"
            show-overflow-tooltip
            label="总销量(元)"
          >
          </el-table-column>
        </el-table>
      </div>

      <div class="bottom-left-panel">
        <span class="text-000 text-18" style="dispaly:block">贡献值排行</span>
        <el-table
          :data="rightTableList"
          style="width: 100%"
          :cell-style="{ border: '0px', padding: '5px 0', height: '20px' }"
          :header-cell-style="{
            border: '0px',
            height: '20px',
            'min-height': '20px',
            padding: '5px 0'
          }"
        >
          <el-table-column label="排名" width="48" align="center">
            <template slot-scope="scope">
              <img
                v-if="scope.row.rankNum == 1"
                src="../../assets/dashboard/rank_0.png"
                class="rank-img"
              />
              <img
                v-if="scope.row.rankNum == 2"
                src="../../assets/dashboard/rank_1.png"
                class="rank-img"
              />
              <img
                v-if="scope.row.rankNum == 3"
                src="../../assets/dashboard/rank_2.png"
                class="rank-img"
              />
              <span v-if="scope.row.rankNum > 3">{{ scope.row.rankNum }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="userName"
            label="用户名称"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="time"
            align="left"
            show-overflow-tooltip
            label="注册时间"
          >
          </el-table-column>
          <el-table-column
            prop="amount"
            align="center"
            show-overflow-tooltip
            label="总贡献值"
          >
          </el-table-column>
          <el-table-column
            prop="monthAmount"
            align="center"
            show-overflow-tooltip
            label="近一月贡献值"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
    <Delail
      :show="delailShow"
      :index="curDelailIndex"
      @close="onClose"
      :title="title"
    ></Delail>
  </div>
</template>

<script>
import echarts from "echarts";
import Delail from "./components/delail.vue";
import {
  getSalesStatistics,
  getDataSummary,
  getExpendTop10
} from "@/api/dashboard";

import { getProductSales } from "@/api/operation";
import { formatDateOne } from "@/utils/utils";

export default {
  name: "Dashboard",
  data() {
    return {
      topList: [
        {
          text: "总销量(元)",
          value: "0",
          change: 0,
          metricType: "amount",
          img: require("../../assets/dashboard/home_0.png")
        },
        {
          text: "总订单量（单)",
          value: "0",
          change: 0,
          metricType: "count",
          img: require("../../assets/dashboard/home_1.png")
        },
        {
          text: "总会员数",
          value: "0",
          change: 0,
          metricType: "count",
          img: require("../../assets/dashboard/home_2.png")
        },
        {
          text: "总提现(元)",
          value: "0",
          change: 0,
          metricType: "amount",
          img: require("../../assets/dashboard/home_3.png")
        },
        {
          text: "总毛利(元)",
          value: "0",
          change: 0,
          metricType: "amount",
          img: require("../../assets/dashboard/icon_xjyj.png")
        }
      ],
      midList: ["销量分析", "订单量分析", "会员数分析", "提现分析"],
      curMid: 0,
      rightMid: 0,
      curTime: null,
      summaryPeriod: "today",
      summaryCustomTime: null,
      bottomList: [
        {
          text: "今日贡献值",
          value: "0",
          detailIndex: 0,
          color: "rgba(61, 158, 251, 0.12)"
        },
        {
          text: "今日现金金额",
          value: "0",
          detailIndex: 1,
          color: "rgba(0, 202, 150, 0.1)"
        },
        {
          text: "今日抽奖次数",
          value: "0",
          detailIndex: 2,
          color: "rgba(245, 80, 119, 0.1)"
        },
        {
          text: "今日数字积分",
          value: "0",
          detailIndex: 4,
          color: "rgba(61, 158, 251, 0.12)"
        },
        {
          text: "新增订单",
          value: "0",
          detailIndex: 5,
          color: "rgba(0, 202, 150, 0.1)"
        },
        {
          text: "售后待处理",
          value: "0",
          detailIndex: 6,
          color: "rgba(245, 80, 119, 0.1)"
        },
        {
          text: "新增客户",
          value: "0",
          detailIndex: 7,
          color: "rgba(246, 185, 79, 0.1)"
        }
      ],
      leftTableList: [],
      rightTableList: [],
      curData: null,
      chart: null,
      delailShow: false,
      curDelailIndex: -1,
      title: ""
    };
  },
  computed: {
    periodPrefix() {
      return this.summaryPeriod === "week"
        ? "本周"
        : this.summaryPeriod === "custom"
        ? "所选区间"
        : this.summaryPeriod === "total"
        ? "累计"
        : "今日";
    },
    comparisonLabel() {
      if (this.summaryPeriod === "custom") return "较上一等长周期";
      return this.summaryPeriod === "week" ? "较上周同期" : "较昨日同期";
    },
    summaryDescription() {
      if (this.summaryPeriod === "week") return "本周一零点至当前的实时数据";
      if (this.summaryPeriod === "custom") {
        if (!this.summaryCustomTime || this.summaryCustomTime.length !== 2)
          return "请选择需要统计的日期范围";
        return `${formatDateOne(
          this.summaryCustomTime[0],
          3
        )} 至 ${formatDateOne(this.summaryCustomTime[1], 3)}`;
      }
      if (this.summaryPeriod === "total") return "平台历史累计数据";
      return "今日零点至当前的实时数据";
    }
  },
  components: { Delail },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  mounted() {
    let _this = this;
    window.addEventListener("resize", function() {
      if (_this.chart) {
        _this.chart.resize();
      }
    });
    this.getWeek(0);
    this.getSummary();
    this.getTop10();
    this.getProduct();
  },
  methods: {
    getTop10() {
      getExpendTop10().then(res => {
        this.rightTableList = res.data;
        this.rightTableList.forEach(item => {
          item.time = formatDateOne(new Date(item.date), 4);
        });
      });
    },
    getProduct() {
      getProductSales().then(res => {
        this.leftTableList = res.data;
        this.leftTableList.forEach((item, index) => {
          item.rankNum = index + 1;
        });
      });
    },
    onClose() {
      this.curDelailIndex = -1;
      this.delailShow = false;
      this.title = "";
    },
    onDetail(item) {
      this.curDelailIndex = item.detailIndex;
      this.title = item.text;
      console.log("title", this.title);
      this.delailShow = true;
    },
    getSummary() {
      getDataSummary(this.getSummaryParams()).then(res => {
        let {
          totalExpend,
          totalBalance,
          totalRaffleTimes,
          totalVcoin,
          totalOrder,
          afterPendingOrder,
          newAddUser
        } = res.data;
        this.bottomList = [
          {
            text: this.periodPrefix + "贡献值",
            value: this.formatMetric(totalExpend),
            detailIndex: 0,
            color: "rgba(61, 158, 251, 0.12)"
          },
          {
            text: this.periodPrefix + "现金金额",
            value: this.formatMetric(totalBalance),
            detailIndex: 1,
            color: "rgba(0, 202, 150, 0.1)"
          },
          {
            text: this.periodPrefix + "抽奖次数",
            value: this.formatCount(totalRaffleTimes),
            detailIndex: 2,
            color: "rgba(245, 80, 119, 0.1)"
          },
          {
            text: this.periodPrefix + "数字积分",
            value: this.formatMetric(totalVcoin),
            detailIndex: 4,
            color: "rgba(61, 158, 251, 0.12)"
          },
          {
            text: "新增订单",
            value: this.formatCount(totalOrder),
            detailIndex: 5,
            color: "rgba(0, 202, 150, 0.1)"
          },
          {
            text: "售后待处理",
            value: this.formatCount(afterPendingOrder),
            detailIndex: 6,
            color: "rgba(245, 80, 119, 0.1)"
          },
          {
            text: "新增客户",
            value: this.formatCount(newAddUser),
            detailIndex: 7,
            color: "rgba(246, 185, 79, 0.1)"
          }
        ];
      });
    },
    formatMetric(value) {
      const number = Number(value || 0);
      return Math.abs(number) >= 1000
        ? (number / 1000).toFixed(2) + "K"
        : number.toFixed(2);
    },
    formatCount(value) {
      return Number(value || 0).toLocaleString("zh-CN");
    },
    onSummaryPeriodChange() {
      if (
        this.summaryPeriod === "custom" &&
        (!this.summaryCustomTime || this.summaryCustomTime.length !== 2)
      ) {
        const end = new Date();
        const start = new Date();
        start.setDate(end.getDate() - 6);
        this.summaryCustomTime = [start, end];
      }
      if (this.summaryPeriod === "custom") {
        this.curTime = this.summaryCustomTime.map(item => new Date(item));
      }
      this.getSummary();
      this.getSales();
    },
    onSummaryCustomTimeChange(value) {
      if (!value || value.length !== 2) return;
      this.curTime = value.map(item => new Date(item));
      this.getSummary();
      this.getSales();
    },
    getSummaryParams() {
      const params = { period: this.summaryPeriod };
      if (
        this.summaryPeriod === "custom" &&
        this.summaryCustomTime &&
        this.summaryCustomTime.length === 2
      ) {
        params.startTime = this.startOfDay(this.summaryCustomTime[0]);
        params.endTime = this.endOfDay(this.summaryCustomTime[1]);
      }
      return params;
    },
    startOfDay(value) {
      const date = new Date(value);
      return date.setHours(0, 0, 0, 0);
    },
    endOfDay(value) {
      const date = new Date(value);
      return date.setHours(23, 59, 59, 999);
    },
    numberDifference(current, previous) {
      return Number(current || 0) - Number(previous || 0);
    },
    formatSignedChange(value, metricType) {
      const number = Number(value || 0);
      const prefix = number > 0 ? "+" : "";
      return (
        prefix +
        (metricType === "count"
          ? this.formatCount(number)
          : this.formatMetric(number))
      );
    },
    getWeek(value) {
      this.curTime = [];
      console.log("startTime", this.curTime);

      let now = new Date();
      console.log("startTime", now);
      let start = new Date(now.getTime() - 3600 * 1000 * 24 * 7);
      console.log("startTime1", start);
      if (value == 0) {
        start = new Date(now.getTime() - 3600 * 1000 * 24 * 7);
      } else if (value == 1) {
        start = new Date(now.getTime() - 3600 * 1000 * 24 * 30);
      } else if (value == 2) {
        start = new Date(now.getTime() - 3600 * 1000 * 24 * 365);
      }
      this.curTime.push(start);
      this.curTime.push(now);
      this.getSales();
    },
    getSales() {
      let params = this.getSummaryParams();
      if (
        this.summaryPeriod !== "custom" &&
        this.curTime &&
        this.curTime.length
      ) {
        params["startTime"] = this.startOfDay(this.curTime[0]);
        params["endTime"] = this.endOfDay(this.curTime[1]);
        console.log("startTime", params);
      }
      getSalesStatistics(params).then(res => {
        this.curData = res.data;
        const grossProfitStatistics = this.curData.grossProfitStatistics || {
          totalAmount: 0,
          todayAmount: 0,
          yesterdayAmount: 0
        };
        this.topList = [
          {
            text: this.periodPrefix + "销售额(元)",
            value: this.formatMetric(this.curData.salesStatistics.totalAmount),
            change: this.numberDifference(
              this.curData.salesStatistics.todayAmount,
              this.curData.salesStatistics.yesterdayAmount
            ),
            metricType: "amount",
            img: require("../../assets/dashboard/home_0.png")
          },
          {
            text: this.periodPrefix + "订单量（单)",
            value: this.formatCount(
              this.curData.orderNumStatistics.totalOrderNum
            ),
            change: this.numberDifference(
              this.curData.orderNumStatistics.todayOrderNum,
              this.curData.orderNumStatistics.yesterdayOrderNum
            ),
            metricType: "count",
            img: require("../../assets/dashboard/home_1.png")
          },
          {
            text: this.periodPrefix + "会员数",
            value: this.formatCount(this.curData.userStatistics.totalUsers),
            change: this.numberDifference(
              this.curData.userStatistics.todayNewUsers,
              this.curData.userStatistics.yesterdayNewUsers
            ),
            metricType: "count",
            img: require("../../assets/dashboard/home_2.png")
          },
          {
            text: this.periodPrefix + "提现(元)",
            value: this.formatMetric(
              this.curData.withdrawStatistics.totalAmount
            ),
            change: this.numberDifference(
              this.curData.withdrawStatistics.todayAmount,
              this.curData.withdrawStatistics.yesterdayAmount
            ),
            metricType: "amount",
            img: require("../../assets/dashboard/home_3.png")
          },
          {
            text: this.periodPrefix + "毛利(元)",
            value: this.formatMetric(grossProfitStatistics.totalAmount),
            change: this.numberDifference(
              grossProfitStatistics.todayAmount,
              grossProfitStatistics.yesterdayAmount
            ),
            metricType: "amount",
            img: require("../../assets/dashboard/icon_xjyj.png")
          }
        ];
        this.initChart();
      });
    },
    initChart() {
      if (!this.chart) {
        let chartDom = document.getElementById("chart");
        this.chart = echarts.init(chartDom);
      }
      let data = [];

      if (this.curMid == 0) {
        data = this.curData.salesStatistics.dataAnalysis;
      } else if (this.curMid == 1) {
        data = this.curData.orderNumStatistics.dataAnalysis;
      } else if (this.curMid == 2) {
        data = this.curData.userStatistics.dataAnalysis;
      } else if (this.curMid == 3) {
        data = this.curData.withdrawStatistics.dataAnalysis;
      }

      let time = [];
      let valueData = [];

      if (data && data.length) {
        data.forEach(item => {
          time.push(item.date);
          valueData.push(item.number);
        });
      }

      let option = {
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: time,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false
          }
        },
        tooltip: {},
        series: [
          {
            data: valueData,
            type: "line",
            smooth: true,
            lineStyle: {
              color: "#7732FC",
              width: 2
            },
            symbol: "circle",
            symbolSize: 8,
            itemStyle: {
              normal: {
                color: "#7732FC"
              }
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(119, 50, 252, 0.85)" // 起始颜色
                },
                {
                  offset: 1,
                  color: "rgba(119, 50, 252, 0)" // 结束颜色
                }
              ])
            }
          }
        ]
      };

      option && this.chart.setOption(option);
    },
    onMid(index) {
      if (index != this.curMid) {
        this.curMid = index;
        this.getSales();
      }
    },
    dateChange(dataArr) {
      console.log("data", dataArr);
      this.curTime = [];
      this.curTime = dataArr;
      this.getSales();
    },
    onRightMid(index) {
      console.log("index", index);
      if (index != this.rightMid) {
        this.rightMid = index;
        this.getWeek(index);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.text-14 {
  font-size: 14px;
}
.text-16 {
  font-size: 16px;
}
.text-18 {
  font-size: 18px;
}
.text-20 {
  font-size: 20px;
}
.text-40 {
  font-size: 40px;
}
.text-bold {
  font-weight: bold;
}
.size-000 {
  color: #000;
}
.size-191 {
  color: #191919;
}
.size-4a4 {
  color: #4a4a4a;
}
.center {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dashboard_warp {
  // background: #f7f7f7;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 106px);
  padding: 30px;
  box-sizing: border-box;
  overflow-y: auto;
  .overview-toolbar {
    width: 100%;
    min-height: 56px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    .overview-title {
      color: #191919;
      font-size: 20px;
      font-weight: 600;
      line-height: 28px;
    }
    .overview-description {
      margin-top: 2px;
      color: #8c8c8c;
      font-size: 13px;
      line-height: 20px;
    }
    .overview-filter {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 12px;
      flex-wrap: wrap;
      .overview-date-picker {
        width: 260px;
      }
    }
  }
  .home-mid {
    width: 100%;
    height: 331px;
    margin-top: 24px;
    min-height: 331px;
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 8px;
    .home-mid-bottom {
      width: 100%;
      height: calc(100% - 65px);
      display: flex;
    }
    .home-mid-top {
      width: 100%;
      height: 65px;
      min-height: 65px;
      display: flex;
      flex-direction: row;
      padding: 0 24px;
      box-sizing: border-box;
      justify-content: space-between;
      position: relative;
      align-items: center;
      border-bottom: 1px solid #e8e8e8;
      .mid-top-right {
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        .custom-chart-hint {
          color: #8c8c8c;
          font-size: 14px;
        }
      }
      .mid-top-left {
        height: 100%;
        display: flex;
        position: relative;
        align-items: center;
        justify-content: center;
        .min-left-list {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          margin-right: 32px;
          cursor: pointer;
          .mid-line {
            width: 100%;
            height: 2px;
            background: #333;
            position: absolute;
            bottom: 0;
          }
        }
      }
    }
  }
  .bottom-panel {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 24px;
    .bottom-left-panel {
      width: 48.5%;
      display: flex;
      flex-direction: column;
      padding: 24px 20px;
      box-sizing: border-box;
      border-radius: 8px;
      background: #fff;
    }
  }
  .mid-bottom-list-panel {
    width: 100%;
    margin-top: 24px;
    height: 92px;
    min-height: 92px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .list-box {
      width: 13.2%;
      height: 100%;
      display: flex;
      padding: 20px 16px;
      box-sizing: border-box;
      flex-direction: column;
      justify-content: space-between;
      position: relative;
      border-radius: 4px;
      cursor: pointer;
      .list-box-jiao {
        position: absolute;
        right: 16px;
      }
    }
  }
  .home-top {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 12px;
    .top-panle {
      min-width: 0;
      min-height: 124px;
      display: flex;
      flex-direction: row;
      padding: 16px 14px;
      box-sizing: border-box;
      border-radius: 8px;
      background: #fff;
      .top-panle-right {
        min-width: 0;
        margin-left: 10px;
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        > span {
          min-width: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .text-18 {
          font-size: 14px;
        }
        .text-40 {
          font-size: 30px;
          line-height: 36px;
        }
        .text-16 {
          font-size: 13px;
        }
      }
      img {
        width: 32px;
        height: 32px;
        flex: 0 0 32px;
        object-fit: contain;
      }
    }
  }
}
.el-table::before {
  height: 0;
}
.rank-img {
  width: 20px;
  height: 24px;
}
.group-img {
  width: 32px;
  height: 32px;
  border-radius: 4px;
}
</style>
